/* eslint-disable no-loop-func */
import _ from "lodash";
import { MarkerType } from "reactflow";
import {
  generateLabelList,
  generateRedirectFlowList,
} from "../CreateForm/DialogBase/logicUtils";

export const getFlowData = (questionData) => {

  if (questionData.length) {
    let xAxis = 0;
    const nodesArray = [];
    const position = { x: 0, y: 0 };
    const optionLabelArr = [];
    questionData.forEach((question, index) => {
      xAxis = xAxis + 250;

      const currentQuestionName = question.name;
      let optionLabels = {};

      question.options.forEach((option) => {
        if (option.id) {
          const obj = { [option.id]: option.label };
          optionLabels = { ...optionLabels, ...obj };
        }
      });
      optionLabelArr.push(optionLabels)
      nodesArray.push({
        id: `${currentQuestionName}`,
        position,
        data: { label: `${index + 1}. ${question.title}`, index: index },
        sourcePosition: "right",
        targetPosition: "left",
        questionData: question,
        customNodeIndex: index,
        type: "customNode",
      });
    });

    xAxis = xAxis + 250;

    nodesArray.push({
      id: "end",
      data: { label: "End" },
      position,
      sourcePosition: "right",
      targetPosition: "left",
    });


    const { redirectNondependentIndexList, redirectDependentIndexList } =
      generateRedirectFlowList(questionData);

    const edgesArray = generateDynamicEdge(
      redirectNondependentIndexList,
      redirectDependentIndexList,
      questionData
    );
    const updatedEdgeArray = []
    optionLabelArr.forEach((option, index) => {
      if (option && edgesArray[index]) { // Null check for option and edgesArray[index]
        Object.entries(option)?.forEach(([key, value]) => {
          const currentEdge = edgesArray[index] ? JSON.parse(JSON.stringify(edgesArray[index])) : null;
          if (currentEdge) { // Null check for currentEdge
            currentEdge['id'] = currentEdge['id'] + '-' + (value || "");
            currentEdge['data'] = currentEdge['data'] || {}; // Ensure 'data' exists
            currentEdge['data']['label'] = value || "next";
            currentEdge['sourceHandle'] = key;
            updatedEdgeArray.push(currentEdge);
          }
        });
      }
    });

    edgesArray.forEach((edge, index) => {
      edge["data"]["options"] = optionLabelArr[index]
    })
    return {
      edges: updatedEdgeArray,
      nodes: nodesArray,
      edgeOptions: optionLabelArr
    };
  }

  return {
    edges: [],
    nodes: [],
    edgeOptions: []
  };
};

const handleCreateEdge = (
  sourceName,
  targetName,
  sourceTitle,
  targetTitle,
  edgesArray,
  optionLabel
) => {
  const isMatchedExists = isEdgeAlreadyExist(
    sourceName,
    targetName,
    edgesArray,
    optionLabel
  );

  if (
    _.isEmpty(isMatchedExists)
      ? true
      : !isMatchedExists?.data?.label.includes(optionLabel)
  ) {
    const updatedOptionLabel = `${isMatchedExists?.data?.label
      ? isMatchedExists?.data?.label + ` /  ` + optionLabel
      : optionLabel
      }`;
    edgesArray.push(
      createEdge(
        sourceName,
        targetName,
        sourceTitle,
        targetTitle,
        updatedOptionLabel
      )
    );
  }
};

const createEdge = (source, target, sourceTitle, targetTitle, label) => {
  const id = label
    ? `edge-${source}-${target}-${label}`
    : `edge-${source}-${target}`;
  return {
    id: `${id}`,
    source: `${source}`,
    target: `${target}`,
    type: "custom",
    markerEnd: { type: MarkerType.ArrowClosed },
    data: {
      label: label ? label : "next",
      sourceName: sourceTitle,
      targetName: targetTitle,
    },
  };
};



const isEdgeAlreadyExist = (sourceName, targetName, edgesArray, label) => {
  const searchValue = label
    ? { source: sourceName, target: targetName, label: label }
    : { source: sourceName, target: targetName };
  if (label) {
    const isMatchedExists = edgesArray.find((edge) => {
      return (
        edge.source === searchValue.source &&
        edge.target === searchValue.target &&
        edge?.data?.label !== "next"
      );
    });
    return isMatchedExists;
  } else {
    const isMatchedExists = edgesArray.some((edge) => {
      return (
        edge.source === searchValue.source &&
        edge.target === searchValue.target
      );
    });
    return isMatchedExists;
  }
};

const generateDynamicEdge = (
  redirectNondependentIndexList,
  redirectDependentIndexList,
  questionData
) => {
  const edgesArray = [];
  const generateFLowList = redirectNondependentIndexList;

  const keyList = Object.keys(generateFLowList).map((data) => Number(data));
  const dependentKeyList = Object.keys(redirectDependentIndexList).map(
    (data) => Number(data)
  );

  Object.entries(generateFLowList).forEach(([key, value]) => {
    if (Object.keys(value).length === 0) {
      const sourceName = questionData[Number(key)]?.name;
      const targetName = questionData[
        keyList[keyList.indexOf(Number(key)) + 1]
      ]?.name
        ? questionData[keyList[keyList.indexOf(Number(key)) + 1]]?.name
        : "end";
      const sourceTitle = questionData[Number(key)]?.title;
      const targetTitle = questionData[
        keyList[keyList.indexOf(Number(key)) + 1]
      ]?.title
        ? questionData[keyList[keyList.indexOf(Number(key)) + 1]]?.title
        : "end";

      const isMatchedExists = isEdgeAlreadyExist(
        sourceName,
        targetName,
        edgesArray
      );

      if (!isMatchedExists)
        edgesArray.push(
          createEdge(sourceName, targetName, sourceTitle, targetTitle)
        );
    } else {
      const currentQuestion =
        questionData[keyList[keyList.indexOf(Number(key))]];

      const optionLabels = generateLabelList(currentQuestion);
      const nextIndex = keyList[keyList.indexOf(Number(key)) + 1];
      const nextNonDependentIndex = nextIndex ? nextIndex : "end";

      const isOtherOption = [];

      Object.entries(value)?.forEach(([subkey, subValue]) => {
        if (_.isEmpty(subValue)) isOtherOption.push(optionLabels[subkey]);
        subValue?.forEach((subIndex, index) => {
          if (index === 0) {
            const sourceName = questionData[Number(key)]?.name;
            const targetName = questionData[subValue[0]]?.name;
            const sourceTitle = questionData[Number(key)]?.title;
            const targetTitle = questionData[subValue[0]]?.title;

            handleCreateEdge(
              sourceName,
              targetName,
              sourceTitle,
              targetTitle,
              edgesArray,
              optionLabels[subkey]
            );
          }
          if (!subValue.includes(Number(key))) {
            if (dependentKeyList.includes(subIndex)) {
              const nextNode = subValue[index + 1]
                ? subValue[index + 1]
                : nextNonDependentIndex;
              generateDependentEdge(
                redirectNondependentIndexList,
                redirectDependentIndexList,
                questionData,
                nextNode,
                optionLabels[subkey],
                Number(subIndex),
                edgesArray
              );
            } else {
              const sourceName = questionData[subIndex]?.name;
              const targetName = subValue[index + 1]
                ? questionData[subValue[index + 1]]?.name
                : questionData[nextNonDependentIndex]?.name;
              const sourceTitle = questionData[subIndex]?.title;
              const targetTitle = subValue[index + 1]
                ? questionData[subValue[index + 1]]?.title
                : questionData[nextNonDependentIndex]?.title;

              if (targetName) {
                handleCreateEdge(
                  sourceName,
                  targetName,
                  sourceTitle,
                  targetTitle,
                  edgesArray,
                  optionLabels[subkey]
                );
              }
            }
          }
        });
      });
      if (isOtherOption.length > 0) {
        const allOtherOptions = isOtherOption.join("/");
        const sourceName = currentQuestion?.name;
        const targetName =
          nextNonDependentIndex === "end"
            ? "end"
            : questionData[nextNonDependentIndex]?.name;
        const sourceTitle = currentQuestion?.title;
        const targetTitle =
          nextNonDependentIndex === "end"
            ? "end"
            : questionData[nextNonDependentIndex]?.title;

        const isMatchedExists = isEdgeAlreadyExist(
          sourceName,
          targetName,
          edgesArray,
          allOtherOptions
        );

        if (_.isEmpty(isMatchedExists) && targetName)
          edgesArray.push(
            createEdge(
              sourceName,
              targetName,
              sourceTitle,
              targetTitle,
              allOtherOptions
            )
          );
      }
    }
  });

  return edgesArray;
};

const generateDependentEdge = (
  redirectNondependentIndexList,
  redirectDependentIndexList,
  questionData,
  nextNonDependentIndex,
  edgeLabel,
  startIndex,
  edgesArray = [],
  flowCreatedArray = []
) => {
  const generateFLowList = redirectDependentIndexList;
  const keyList = Object.keys(generateFLowList).map((data) => Number(data));
  const NondependentKeyList = Object.keys(
    redirectNondependentIndexList
  ).map((data) => Number(data));

  Object.entries(generateFLowList).forEach(([key, value]) => {
    if (Number(key) === startIndex && startIndex !== null) {
      const currentQuestion =
        questionData[keyList[keyList.indexOf(Number(key))]];

      const isOtherOption = [];

      if (!_.isEmpty(value)) {
        if (!flowCreatedArray.includes(Number(key))) {
          const optionLabels = generateLabelList(currentQuestion);
          Object.entries(value)?.forEach(([subkey, subValue]) => {
            if (_.isEmpty(subValue))
              isOtherOption.push(optionLabels[subkey]);
            if (subValue.length > 0) {
              subValue?.forEach((subIndex, index) => {
                flowCreatedArray.push(Number(key));
                if (index === 0) {
                  const sourceName = questionData[Number(key)]?.name;
                  const targetName = questionData[subValue[0]]?.name;
                  const sourceTitle = questionData[Number(key)]?.title;
                  const targetTitle = questionData[subValue[0]]?.title;
                  handleCreateEdge(
                    sourceName,
                    targetName,
                    sourceTitle,
                    targetTitle,
                    edgesArray,
                    optionLabels[subkey]
                  );
                }
                if (!subValue.includes(Number(key))) {
                  if (
                    keyList.includes(subIndex) &&
                    !flowCreatedArray.includes(subIndex)
                  ) {
                    const nextNode = subValue[index + 1]
                      ? subValue[index + 1]
                      : nextNonDependentIndex;
                    generateDependentEdge(
                      redirectNondependentIndexList,
                      redirectDependentIndexList,
                      questionData,
                      nextNode,
                      optionLabels[subkey],
                      subIndex,
                      edgesArray,
                      flowCreatedArray
                    );
                  } else {
                    const sourceName = questionData[subIndex]?.name;
                    const targetName =
                      questionData[subValue[index + 1]]?.name;
                    const sourceTitle = questionData[subIndex]?.title;
                    const targetTitle =
                      questionData[subValue[index + 1]]?.title;

                    if (targetName) {
                      handleCreateEdge(
                        sourceName,
                        targetName,
                        sourceTitle,
                        targetTitle,
                        edgesArray,
                        optionLabels[subkey]
                      );
                    }
                  }
                }
              });
            }
          });

          if (isOtherOption.length > 0) {
            const allOtherOptions = isOtherOption.join("/");
            const sourceName = currentQuestion?.name;
            const targetName =
              nextNonDependentIndex === "end"
                ? "end"
                : questionData[nextNonDependentIndex]?.name;
            const sourceTitle = currentQuestion?.title;
            const targetTitle =
              nextNonDependentIndex === "end"
                ? "end"
                : questionData[nextNonDependentIndex]?.title;
            if (targetName) {
              handleCreateEdge(
                sourceName,
                targetName,
                sourceTitle,
                targetTitle,
                edgesArray,
                allOtherOptions
              );
            }
          }
        }
      } else {
        const sourceName = questionData[Number(key)]?.name;
        const targetName =
          nextNonDependentIndex === "end"
            ? "end"
            : questionData[nextNonDependentIndex]?.name;
        const sourceTitle = questionData[Number(key)]?.title;
        const targetTitle =
          nextNonDependentIndex === "end"
            ? "end"
            : questionData[nextNonDependentIndex]?.title;
        startIndex = null;
        if (
          NondependentKeyList.includes(nextNonDependentIndex) ||
          targetName === "end"
        ) {
          const isMatchedExists = isEdgeAlreadyExist(
            sourceName,
            targetName,
            edgesArray
          );
          if (!isMatchedExists)
            edgesArray.push(
              createEdge(sourceName, targetName, sourceTitle, targetTitle)
            );
        } else {
          handleCreateEdge(
            sourceName,
            targetName,
            sourceTitle,
            targetTitle,
            edgesArray,
            edgeLabel
          );
        }
      }
    }
  });

  return edgesArray;
};

export const logicalTypes = ["dropdown", "multi-select", "select", "image-multi-select", "image-select"]